import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from 'classnames';

import {
  initModal,
  closeModal
} from "../actions";

class Modal extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleEscKey = this.handleEscKey.bind(this);
  }

  modalClassName() {
    const { modal, name } = this.props;
    return classNames(
      'ds-modal',
      this.props.modalClassName,
      { '_open': modal[name] }
    )
  }

  containerClassName() {
    return classNames(
      'ds-container',
      this.props.containerClassName,
    )
  }

  gridClassName() {
    return classNames(
      'grid',
      this.props.gridClassName,
    )
  }

  cardClassName() {
    return classNames('ds-card', this.props.cardClassName);
  }

  closeModal = () => {
    const { closeModal, persistent } = this.props;
    if (persistent) return;
    closeModal();
  }

  closeModal = () => {
    const { 
      persistent,
      closeModal,
      onCloseModal,
    } = this.props;

    if (persistent) return;

    if (onCloseModal) {
      onCloseModal()
    }

    closeModal();
  }

  componentWillMount() {
    if (this.props.override_esc_key) return;

    document.addEventListener("keydown", this.handleEscKey, false);
  }

  // when the component unmounts, remove the Esc key event listener
  componentWillUnmount() {
    if (this.props.override_esc_key) return;

    document.removeEventListener("keydown", this.handleEscKey, false);
  }

  handleEscKey(e) {
    if(e.keyCode === 27) {
      this.closeModal()
    }
  }

  handleClick(e) {
    if(this.props.persistent ||
      !this.props.overlayTrigger ||
      e.target.className !== 'ds-container') return;

    this.closeModal()
  }

  renderCloseLink() {
    if (this.props.persistent || this.props.override_close) return;

    return (
      <button
        data-test="close-modal-button"
        className="ds-btn -secondary --micro _icon _rounded _closeModal" 
        onClick={this.closeModal}
      >
        <i className="materialIcon">close</i>
      </button>
    );
  }

  renderTitle() {
    if(!this.props.title) return;
    return <h2 className="cardTitle"> {this.props.title} </h2>;
  }

  get style() {
    return { "overflowY": "scroll", ...this.props.style };
  }

  // TODO: remove style prop later
  render() {
    return (
      <div className={this.modalClassName()} onClick={this.handleClick} style={this.style}>
        <div className={this.containerClassName()} id={this.props.id}>
          <div className={this.gridClassName()}>
            <div className={this.cardClassName()}>
              {this.renderCloseLink()}
              {this.renderTitle()}
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.shared.ui.modal,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    initModal: (name, open) => dispatch(initModal(name, open)),
    closeModal: () => dispatch(closeModal(props.name)),
  };
};

Modal.defaultProps = {
  id: "modal",
  name: "default",
  persistent: false,
  overlayTrigger: true,
};

Modal.propTypes = {
  modalClassName: PropTypes.string,
  gridClassName: PropTypes.string,
  cardClassName: PropTypes.string,
  onCloseModal: PropTypes.func,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  open: PropTypes.boolean,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);



// WEBPACK FOOTER //
// ./src/features/shared/containers/Modal.js